var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"center-page"},[_c('img',{staticClass:"logo",attrs:{"src":require("@assets/images/AOlogo-long.png"),"alt":"Logo"}}),_c('h6'),_c('h1',{staticClass:"mt-4"},[_vm._v("Our website is under construction. We'll have more for you soon!")]),_c('p',[_vm._v("- The AOarmor Team")])])
}]

export { render, staticRenderFns }